export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'API-nøgle',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    error: 'Ændringerne kunne ikke gemmes',
    success: 'Ændringerne er gemt',
  },
  connected: {
    title: 'ExpertOrder er tilsluttet',
    description: 'Denne integration er sat op.',
  },
};
